import "react";
import { Email, FormLayout } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
// src/modules/AuthWrapper2/components/Login/views/PasswordReset.tsx
function PasswordReset({ email, error, loading, onCancel, onChangeEmail, onSubmit }) {
	return /* @__PURE__ */ jsxs(FormLayout, {
		dividers: "space",
		heading: "",
		children: [/* @__PURE__ */ jsx(Email, {
			disabled: loading,
			error,
			label: "Email",
			onChangeValue: onChangeEmail,
			placeholder: "john-doe@gmail.com",
			subText: "If an account exists for this email, we'll send instructions for resetting the password.",
			value: email
		}), /* @__PURE__ */ jsx(FormLayout.Controls, {
			onCancel,
			onSubmit,
			submitting: loading && "Submitting"
		})]
	});
}
export { PasswordReset };

//# sourceMappingURL=PasswordReset.js.map